import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { useDialog, useRequestState } from '@app/hooks';
import { DeleteDialog } from '@app/components/dialog';
import { IHoliday } from '../types';
import { AddHolidayPopup } from './add-holiday-popup';
import { deleteHoliday } from '../slice';
import { selectDeleteHolidayState } from '../selectors';

interface Props {
  row: IHoliday;
}

const HolidayRowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const editDialog = useDialog();
  const dispatch = useDispatch();

  const actions = [
    { label: Strings.rowActions.edit, callback: editDialog.show },
    { label: Strings.rowActions.delete, callback: deleteDialog.show },
  ];
  const { loading } = useRequestState({
    stateSelector: selectDeleteHolidayState,
    onSuccess: deleteDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });
  const onPressDelete = () => {
    dispatch(
      deleteHoliday({
        id: row?.id,
      })
    );
  };
  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.holiday.holiday}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.holiday.holiday)}
        loading={loading}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
        onClose={deleteDialog.hide}
      />
      <AddHolidayPopup open={editDialog.visible} onClose={editDialog.hide} holiday={row} />
    </>
  );
};

export { HolidayRowActions };
